import { render } from "./SidebarSubmenuItem.vue?vue&type=template&id=7c7abbbc"
import script from "./SidebarSubmenuItem.vue?vue&type=script&lang=js"
export * from "./SidebarSubmenuItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__